import logger from '3-foundation/Logging/logger';
import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstTheme } from '../DataTypes/themeMapper';
import { mapFirstVideo } from '../DataTypes/videoMapper';

interface Props {
	content: {
		contentType: 'heroCardSearch';
		properties: {
			kicker: string;
			heading: string;
			text: string | null;
			image: Umbraco.Image[];
			altText: string;
			video: Umbraco.Video[];
		};
	};
	settings: {
		properties: {
			theme: { theme: Umbraco.TreeNode }[];
			layout: 'Small Media' | 'Full Width Center';
		};
	};
}

export const mapHeroCardSearch = ({ content, settings }: Props): Content.HeroCardSearch => {
	const { kicker, heading, text, image, altText, video } = content?.properties ?? {};
	const { theme, layout } = settings?.properties ?? {};

	try {
		return {
			documentType: content?.contentType,
			content: {
				kicker: kicker ?? null,
				heading,
				text: text ?? null,
				video: mapFirstVideo(video) ?? null,
				image: mapFirstImage(image),
				altText: altText ?? null,
			},
			settings: {
				properties: {
					theme: mapFirstTheme(theme),
					layout,
				},
			},
		};
	} catch (e) {
		logger.error(`Could not map HeroCardSearch \nCause: ${e}`);
		throw new Error(`Could not map HeroCardSearch \nCause: ${e}`, { cause: e });
	}
};
